import { useContext, useEffect, useState } from "react";
import { Form, Modal, Radio, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import { setAgeId, setProfID, updateAge, updateAgeName } from "../../Reducer/localStorageSlice";
import "../editProfile/profile.scss";

export default function LoginAgeRestriction() {
    const dispatch = useDispatch()
    const localData = useSelector((state) => state?.localStorage)
    const { profileOpen, setProfileOpen, setOpenMicrosite } = useContext(GlobalContext);
    const { age, profID } = localData

    const [localProfileOpen, setLocalProfileOpen] = useState(!age || age === '18')
    const [showAgeRestrictionMessage, setShowAgeRestrictionMessage] = useState(age === '18' || false)

    const [prof, setProf] = useState(profID)
    const [ageGroups, setAgeGroups] = useState([]);
    const [ageGroupData, setAgeGroupsData] = useState([]);
    const [selectedAgeGroupsData, setSelectedAgeGroupsData] = useState();

    const [showAlert, setShowAlert] = useState(false);
    const [isActive, setActive] = useState("false");

    const [isDropdownDisabled, setisDropdownDisabled] = useState(true);
    const handleOk = () => {
       if (!age || !prof) { setShowAlert(true) }
        if (age && prof) {
            if (age === 18 || age?.includes(18) ) {
                setShowAgeRestrictionMessage(true)
                setProfileOpen(false)
                setOpenMicrosite(true)
            }
            else {
                setProfileOpen(false)
                setOpenMicrosite(true)
                setLocalProfileOpen(false)
            }
        }


    };

    const getAgeGroups = async () => {
        try {
            const response = await getRequest(userapiservice.getEndUserAgeGroups());
            setAgeGroups(response);
        } catch (e) {
            Modal.error({
                title: "Error",
                content: e.response?.data?.message || "Something went wrong...",
            });
        }
    };

    const getAgeData = async (value) => {
        try {
            const response = await getRequest(userapiservice.getWhatDoYouDo(value));
            setAgeGroupsData(response);
        } catch (e) {
            Modal.error({
                title: "Error",
                content: e.response?.data?.message || "Something went wrong...",
            });
        }
    };

    const ageGroupDataChange = (groupData) => {
        // setUpdatedDesignation(groupData);
        setSelectedAgeGroupsData(groupData);
    };

    const toggleClass = () => {
        setActive(!isActive);
    };

    const setLocalAge = (value, id) => {
        if (value === "< 18") {
            dispatch(updateAge("18"))
            dispatch(setAgeId(id))
            dispatch(updateAgeName(value))
        } else if (value === "19 - 23") {
            dispatch(updateAge("23"))
            dispatch(setAgeId(id))

            dispatch(updateAgeName(value))
        } else if (value === "24 - 37") {
            dispatch(updateAge("37"))
            dispatch(setAgeId(id))
            dispatch(updateAgeName(value))
        } else if (value === "38 - 53") {
            dispatch(updateAge("53"))
            dispatch(setAgeId(id))
            dispatch(updateAgeName(value))
        } else if (value === "54+") {
            dispatch(updateAge("53"))
            dispatch(setAgeId(id))
            dispatch(updateAgeName(value))
        }
    };

    const AgeRestrictionNotice = () => {
        return (
          <div className="age-restriction-card d-flex justify-content-center align-items-center ">
            <div
              className="age-restriction-card-content text-center p-2 md:p-4"
              style={{ maxWidth: "500px" }}
            >
              <div className="card-body">
                {/* <h5 className=" age-restriction-card-title card-title text-danger ">
                            Before You Proceed
                        </h5> */}
                {/* <p className=" age-restriction-card-description card-text text-muted">
                            Thank you for your interest in our application. At this time, we are
                            only supporting login for users who are above 18. We appreciate your
                            understanding.
                        </p> */}
                <p className=" age-restriction-card-description card-text text-muted">
                  Sorry, the login feature is not available to unders 18's.
                </p>
                <a href="/microsite" className="age-restriction-card-btn btn">
                  Continue browsing
                </a>
              </div>
            </div>
          </div>
        );
    };

    useEffect(() => {
        getAgeGroups();
    }, []);

    return (
        <Modal
            closable={false}
            centered
            open={profileOpen || localProfileOpen}

            okText="Apply"
            className="profile-modal-container profile-modal"
            footer={[
                !showAgeRestrictionMessage && <button
                    className="btn btn-danger profile-submit-btn"
                    type="button"
                    onClick={handleOk}
                >
                    Continue
                </button>,
            ]}
        >

            {showAgeRestrictionMessage ? <AgeRestrictionNotice /> :

                <>
                    <div className="d-flex align-items-center justify-content-between title-bar text-cap " >
                        <strong  >
                            Create a profile if you want to save or review
                        </strong>
                    </div>
                    <div
                        className="radio-group-space"
                        direction="vertical"
                    >
                        <label className="">Select your age</label>

                        <div className="" >
                            <Radio.Group
                                className="age-radio"

                                buttonStyle="solid"
                                style={{
                                    // marginBottom: 16,
                                    display: "block",
                                    textAlign: "center",
                                    width: "100%",
                                }}
                            >
                                <div className="create-age-radio overflow-hidden">
                                    {ageGroups && ageGroups.length > 0
                                        ? ageGroups.map((ageGroup) => (
                                            <Radio.Button
                                                key={ageGroup?.id}
                                                value={ageGroup?.id}
                                                // type="radio"
                                                onClick={() => {
                                                    getAgeData(ageGroup?.id);
                                                    setisDropdownDisabled(false);
                                                    dispatch(setAgeId(ageGroup?.id))
                                                    dispatch(updateAgeName(ageGroup?.value))
                                                    dispatch(updateAge(ageGroup?.value))
                                                    setSelectedAgeGroupsData(null);
                                                    toggleClass();
                                                    setLocalAge(ageGroup?.value, ageGroup?.id);
                                                }}
                                            >
                                                {ageGroup?.value}
                                            </Radio.Button>
                                        ))
                                        : ""}
                                </div>
                            </Radio.Group>
                        </div>
                        <Form>
                            <Form.Item  >
                                <label>What do you do?</label>
                                <div className="p-2" >
                                    <Select
                                        className="customSelect "
                                        disabled={isDropdownDisabled}
                                        placeholder="Enter what you do"
                                        value={selectedAgeGroupsData}
                                        onChange={(e) => {
                                            const profID = ageGroupData?.find(
                                                (element) => element.value === e
                                            );
                                            setProf(profID?.id);
                                            dispatch(setProfID(profID?.id))
                                            ageGroupDataChange(e);
                                        }}
                                    >
                                        {ageGroupData &&
                                            ageGroupData?.map((ageGroupData) => (
                                                <Select.Option
                                                    key={ageGroupData?.id}
                                                    value={ageGroupData?.value}
                                                >
                                                    {ageGroupData?.value}
                                                </Select.Option>
                                            ))}
                                    </Select>
                                </div>
                            </Form.Item>
                        </Form>
                    </div>

                    {showAlert && (
                        <div className="alert-container">
                            <label
                                className="age-alert"
                                style={{ color: "red", width: "100%" }}
                            >
                                Please set age & profession!
                            </label>
                        </div>
                    )}
                </>}


        </Modal>
    );
}
